import React, { Component } from 'react'
import { IS_WEB, IS_PROD, IS_SANDBOX } from '../../config/'

import Button from './Button'
import Input from './Input'

// https://community.frontapp.com/t/80m1kc
const FRONT_FORM_ID =
  'https://webhook.frontapp.com/forms/snips/b881975d5babdc2d71b7092cbac5e0a6f68d7a0101e6b9f5170ac8820f3ff942'

const ContactForm = class ContactForm extends Component {
  constructor () {
    super()
    // contact form submit success, see https://community.frontapp.com/t/80m1kc
    // NOTE: frontapp always redirects back to snips.ai (PROD); it is not
    // configured to work with our local/staging domains
    let submitted = false
    if (IS_WEB && /[?&]code=ok/.test(window.location.search)) {
      submitted = true
    }
    this.state = {
      sending: false,
      submitted,
      error: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit (e) {
    if (!(IS_PROD && !IS_SANDBOX)) {
      console.log('NOT sending the contact email because dev/staging')
      e.preventDefault()
      return
    }
    this.setState({ sending: true, error: false })
  }

  render () {
    const { error, submitted, sending } = this.state
    if (submitted) {
      return (
        <div className='h3 py2'>
          Thanks for your message, we will get in touch shortly!
        </div>
      )
    }
    return (
      <div>
        {error && <div className='py2 mb2 error'>{error}</div>}
        {!(IS_PROD && !IS_SANDBOX) && (
          <div className='mb2'>
            DEV note: this form only works on production website, snips.ai
          </div>
        )}
        <form
          className='md-flex flex-wrap col-12 sm-col-10 md-col-8 mx-auto'
          action={FRONT_FORM_ID}
          method='POST'
          encType='multipart/form-data'
          acceptCharset='utf-8'
          onSubmit={this.handleSubmit}
        >
          <div className='col-12 md-col-6 mb2 px1'>
            <Input name='name' placeholder='Name' />
          </div>

          <div className='col-12 md-col-6 px1 mb2'>
            <Input type='email' required name='email' placeholder='Email*' />
          </div>

          <div className='col-12 px1 mb3'>
            <Input
              Element='textarea'
              rows={8}
              required
              name='body'
              placeholder='Message*'
            />
          </div>
          <div className='flex justify-between items-center full-width px1'>
            <div className='very-small grey'>* Required field</div>
            <Button
              type='submit'
              className='button button--primary button--wide button--thin'
            >
              {sending ? 'Sending…' : 'Send'}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/ContactForm.js